import styled from "styled-components";
import { viewSizeCalculator } from "../../../utils";

export const SliderContainer = styled.div`
  position: relative;
  //width: 18.75rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  //margin-bottom: ${viewSizeCalculator(2.2)};
`;

export const RangeInput = styled.input`
  position: absolute;
  width: 100%;
  pointer-events: none;
  -webkit-appearance: none;
  box-shadow: 0rem 0.0625rem 0.25rem 0rem #33333333 inset;
  background: transparent;
  /* opacity: 10%; */
  z-index: ${(props) => (props.zIndex ? props.zIndex : 1)};

  &::-webkit-slider-thumb {
    pointer-events: all;
    position: relative;
    width: 1rem;
    height: 1rem;
    background: #333333;
    border-radius: 50%;
    cursor: pointer;
    -webkit-appearance: none;
    transform: translateY(-0.375rem);
  }

  &::-webkit-slider-runnable-track {
    height: 0.25rem;
    background: transparent;
  }
`;

// export const RangeInput = styled.input`
//   position: absolute;
//   width: 100%;
//   -webkit-appearance: none;
//   background: transparent;
//   z-index: ${(props) => (props.zIndex ? props.zIndex : 1)};
//   box-shadow: 0rem 0.0625rem 0.25rem 0rem #33333333 inset;
//   cursor: pointer;

//   /* Only block pointer events for the track, NOT the thumb */
//   pointer-events: none;

//   &::-webkit-slider-thumb {
//     pointer-events: all; /* Allows thumb dragging */
//     position: relative;
//     width: 1rem;
//     height: 1rem;
//     background: #333333;
//     border-radius: 50%;
//     cursor: pointer;
//     -webkit-appearance: none;
//     transform: translateY(-0.375rem);
//   }

//   &::-webkit-slider-runnable-track {
//     height: 0.25rem;
//     background: transparent;
//     pointer-events: all; /* 🔥 Make sure the track is clickable */
//   }
// `;

export const SliderTrack = styled.div`
  position: absolute;
  height: 0.25rem;
  background: transparent;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 0.125rem;
  pointer-events: none;
`;

export const SliderPoint = styled.div`
  position: absolute;
  transform: translateX(-50%);
  top: ${viewSizeCalculator(-0.2)};
  width: ${viewSizeCalculator(0.58)};
  height: ${viewSizeCalculator(0.58)};
  background: #bdbdbd;
  border-radius: 50%;
  cursor: pointer;
`;

export const Title = styled.div`
  font-size: ${viewSizeCalculator(0.8125)};
  font-weight: 400;
  padding-left: ${viewSizeCalculator(0.2)};
  opacity: ${({ disabled }) => (disabled ? "30%" : "1")};
`;

export const MinMaxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

export const MinMaxPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${viewSizeCalculator(-0.9)};
  font-size: ${viewSizeCalculator(0.8)};
  padding: 0px ${viewSizeCalculator(0.2)};
  color: #808080;
`;

export const Tooltip = styled.div`
  position: absolute;
  top: -2rem;
  transform: translateX(-50%);
  background: #333;
  color: #fff;
  padding: 0.15rem 0.6rem;
  font-size: 0.65rem;
  border-radius: 0.25rem;
  white-space: nowrap;
  display: none;
  display: flex;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;

  // ${RangeInput}:hover + &,
  // ${RangeInput}:focus + &,
  // ${RangeInput}:active + & {
  //   opacity: 1;
  // }
`;

export const TooltipArrow = styled.div`
  position: absolute;
  bottom: ${viewSizeCalculator(-0.3)};
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: ${viewSizeCalculator(0.35)} solid transparent;
  border-right: ${viewSizeCalculator(0.35)} solid transparent;
  border-top: ${viewSizeCalculator(0.35)} solid #333;
`;
